import React, { useState } from "react";
import { Redirect } from "react-router-dom";

function SubmissionDialog(props) {
  const { type } = props;
  const [redirectStatus] = useState(true);

  if (redirectStatus) {
    if (type === "Datasets")
      return (
        <Redirect
          to={{
            pathname: "/datasetsubmitted",
            tableContents: props.tableContents,
            filename: props.filename,
            projectId: props.projectId,
            nextPage: "/submitfiles",
            nextPageLabel: "GO TO SUBMIT FILE(s)",
          }}
        />
      );
    if(type === "Files") {
      return (
        <Redirect
          to={{
            pathname: "/filesubmitted",
            tableContents: props.tableContents,
            filename: props.filename,
            projectId: props.projectId,
            nextPage: "/",
            nextPageLabel: "GO TO MAIN PAGE",
          }}
        />
      );
    }
    
    return (
      <Redirect
        to={{
          pathname: "/projectsubmitted",
          tableContents: props.tableContents,
          filename: props.filename,
          nextPage: "/",
          nextPageLabel: "GO TO MAIN PAGE",
        }}
      />
    );
  }
}

export default SubmissionDialog;
